// extracted by mini-css-extract-plugin
export default {"main":"App_main__5VZ13","logo":"App_logo__KFImf","frame":"App_frame__wpIad","text":"App_text__KxieM"};